/*!
 * Copyright © 2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatLegacySelect, MatLegacySelectChange } from '@angular/material/legacy-select';
import { EVehiclesSortType } from '../../../core/models';

@Component({
  selector: 'fm-status-sort-options',
  templateUrl: './status-sort-options.component.html',
  styleUrls: ['./status-sort-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusSortOptionsComponent {
  @Input()
  public vehicleSortTypeSelected: EVehiclesSortType;

  @Output()
  public sortParamChanged: EventEmitter<EVehiclesSortType> = new EventEmitter();

  @ViewChild('select', { static: false })
  public select: MatLegacySelect;

  public EVehiclesSortType = EVehiclesSortType;

  public onSortParamChange(item: MatLegacySelectChange): void {
    this.sortParamChanged.emit(item.value as EVehiclesSortType);
  }

  public openDropdownPanel(): void {
    this.select.open();
  }
}
